import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { copyCarouselHasFinished } from '../store/loading-status/action-creators';
import { doesCarouselTitleExist, getCarouselTitle } from './carouselUtils';
let titleIndex = 1;
const copySwitchingInterval = 2000;
export const useCopyCarousel = ({
  baseI18n,
  loadingKey,
  canSwitchCopy = true,
  textDisplayDelay = 0,
  shouldGoRound
}) => {
  const firstI18n = `${baseI18n}_1`;
  const hasCopyCaroussel = isValidI18nKey(firstI18n);
  const [copyToDisplay, setCopyToDisplay] = useState(firstI18n || baseI18n);
  const dispatch = useDispatch();
  useEffect(() => {
    let timeoutId;
    let intervalId;

    if (hasCopyCaroussel) {
      timeoutId = setTimeout(() => {
        intervalId = setInterval(() => {
          if (canSwitchCopy) {
            titleIndex += 1;

            if (!doesCarouselTitleExist(baseI18n, titleIndex)) {
              dispatch(copyCarouselHasFinished(loadingKey));
              titleIndex = shouldGoRound ? 1 : titleIndex - 1;
              clearInterval(intervalId);
              intervalId = -1;
            }

            setCopyToDisplay(getCarouselTitle(baseI18n, titleIndex));
          }
        }, copySwitchingInterval);
      }, textDisplayDelay);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [baseI18n, hasCopyCaroussel, loadingKey, dispatch, canSwitchCopy, textDisplayDelay, shouldGoRound]);
  return {
    copyToDisplay
  };
};